import React, { useEffect, useState, useRef, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, CalendarIcon, MusicIcon, UsersIcon } from 'lucide-react';
interface TimelineEvent {
  id: number;
  date: string;
  title: string;
  description: string;
  image?: string;
  spotifyId?: string;
  category: 'release' | 'concert' | 'formation' | 'announcement';
}
const Timeline = () => {
  const [activeEvent, setActiveEvent] = useState(0);
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const timelineRef = useRef<HTMLDivElement>(null);
  const events: TimelineEvent[] = [{
    id: 1,
    date: 'JANUARY 2021',
    title: 'PROJECT INCEPTION',
    description: 'Garbs and Russell meet to discuss the possibility of a new music project that would blend their unique styles and influences, laying the groundwork for what would become Fabric Reality.',
    image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    category: 'formation'
  }, {
    id: 2,
    date: 'APRIL 2021',
    title: 'FIRST RECORDING SESSION',
    description: "The duo enters the studio for their first official recording session, experimenting with synth sounds and vocal techniques that would define their signature 'Interstellar Rock' sound.",
    image: 'https://images.unsplash.com/photo-1598653222000-6b7b7a552625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    category: 'formation'
  }, {
    id: 3,
    date: 'AUGUST 2021',
    title: 'DEBUT SINGLE: EXHIBITION',
    description: "Fabric Reality releases their first single 'Exhibition' to critical acclaim, introducing listeners to their unique blend of atmospheric synths, driving beats, and introspective lyrics.",
    image: 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    spotifyId: '4SD9pVb5ekH6ZgpaZ0BgB3',
    category: 'release'
  }, {
    id: 4,
    date: 'NOVEMBER 2021',
    title: 'SECOND SINGLE: HOW IT FEELS TO LOVE YOU LATELY',
    description: 'Building on the momentum of their debut, the duo releases their second single, showcasing a more emotional and melodic side to their sound.',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    spotifyId: '1yWWvKbLK452yLC3kBGIdb',
    category: 'release'
  }, {
    id: 5,
    date: 'JANUARY 2022',
    title: 'THIRD SINGLE: SUNSET ON SATURN',
    description: "The final single before their EP release, 'Sunset On Saturn' cements Fabric Reality's reputation for creating immersive, cosmic soundscapes.",
    image: 'https://images.unsplash.com/photo-1614732414444-096e5f1122d5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
    spotifyId: '5jF95Jn7XAXxhWLWN5wGMh',
    category: 'release'
  }, {
    id: 6,
    date: 'FEBRUARY 2022',
    title: 'DEBUT EP RELEASE',
    description: 'Fabric Reality releases their self-titled debut EP, featuring all previous singles plus new tracks that expand their sonic universe.',
    image: 'https://images.unsplash.com/photo-1671920090611-9a40303b52cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    category: 'release'
  }, {
    id: 7,
    date: 'JUNE 2022',
    title: 'FIRST LIVE PERFORMANCE',
    description: 'The band makes their live debut, translating their studio sound into an immersive concert experience that captivates the audience.',
    image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    category: 'concert'
  }, {
    id: 8,
    date: 'OCTOBER 2022',
    title: 'UK MINI TOUR',
    description: 'Fabric Reality embarks on their first mini-tour, playing intimate venues across the UK and building a dedicated fanbase.',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    category: 'concert'
  }, {
    id: 9,
    date: 'MARCH 2023',
    title: 'NEW ALBUM ANNOUNCEMENT',
    description: 'The band announces they are working on their debut full-length album, promising to push their cosmic sound into new dimensions.',
    image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    category: 'announcement'
  }, {
    id: 10,
    date: 'PRESENT DAY',
    title: 'WORKING ON NEW MATERIAL',
    description: 'Fabric Reality is currently in the studio working on new material, pushing the boundaries of their sound even further into uncharted cosmic territory.',
    image: 'https://images.unsplash.com/photo-1571974599782-fac9c6b08463?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
    category: 'formation'
  }];
  // Filter events based on category
  const filteredEvents = activeFilter ? events.filter(event => event.category === activeFilter) : events;
  // Update activeEvent when filteredEvents changes
  useEffect(() => {
    setActiveEvent(0);
  }, [activeFilter]);
  useEffect(() => {
    if (timelineRef.current) {
      const timelineWidth = timelineRef.current.scrollWidth;
      const containerWidth = timelineRef.current.clientWidth;
      const maxScroll = timelineWidth - containerWidth;
      const scrollPosition = activeEvent / (filteredEvents.length - 1) * maxScroll;
      timelineRef.current.scrollLeft = scrollPosition;
    }
  }, [activeEvent, filteredEvents.length]);
  const nextEvent = () => {
    setActiveEvent(prev => Math.min(prev + 1, filteredEvents.length - 1));
  };
  const prevEvent = () => {
    setActiveEvent(prev => Math.max(prev - 1, 0));
  };
  const currentEvent = filteredEvents[activeEvent];
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'release':
        return <MusicIcon size={16} className="mr-1 text-pink-400" data-id="element-571" />;
      case 'concert':
        return <UsersIcon size={16} className="mr-1 text-purple-400" data-id="element-572" />;
      case 'formation':
        return <CalendarIcon size={16} className="mr-1 text-blue-400" data-id="element-573" />;
      case 'announcement':
        return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1 text-green-400" data-id="element-574">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" data-id="element-575"></polygon>
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" data-id="element-576"></path>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" data-id="element-577"></path>
          </svg>;
      default:
        return null;
    }
  };
  return <section className="py-16" data-id="element-578">
      <div className="max-w-6xl mx-auto" data-id="element-579">
        <h2 className="text-5xl font-bold mb-12 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-580">
          TIMELINE
        </h2>
        <div className="mb-8 flex flex-wrap gap-3" data-id="element-581">
          <button onClick={() => setActiveFilter(null)} className={`px-4 py-2 rounded-lg transition-colors ${activeFilter === null ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-582">
            All Events
          </button>
          <button onClick={() => setActiveFilter('release')} className={`px-4 py-2 rounded-lg transition-colors flex items-center ${activeFilter === 'release' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-583">
            <MusicIcon size={16} className="mr-2" data-id="element-584" />
            Releases
          </button>
          <button onClick={() => setActiveFilter('concert')} className={`px-4 py-2 rounded-lg transition-colors flex items-center ${activeFilter === 'concert' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-585">
            <UsersIcon size={16} className="mr-2" data-id="element-586" />
            Concerts
          </button>
          <button onClick={() => setActiveFilter('formation')} className={`px-4 py-2 rounded-lg transition-colors flex items-center ${activeFilter === 'formation' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-587">
            <CalendarIcon size={16} className="mr-2" data-id="element-588" />
            Formation
          </button>
          <button onClick={() => setActiveFilter('announcement')} className={`px-4 py-2 rounded-lg transition-colors flex items-center ${activeFilter === 'announcement' ? 'bg-pink-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-589">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-590">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" data-id="element-591"></polygon>
              <path d="M15.54 8.46a5 5 0 0 1 0 7.07" data-id="element-592"></path>
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14" data-id="element-593"></path>
            </svg>
            Announcements
          </button>
        </div>
        <div className="bg-black/60 backdrop-blur-sm rounded-lg border border-indigo-500/30 shadow-lg shadow-indigo-500/20 overflow-hidden p-6" data-id="element-594">
          {filteredEvents.length > 0 ? <>
              {/* Main Event Display */}
              <div className="mb-12" data-id="element-595">
                <div className="flex flex-col md:flex-row gap-8" data-id="element-596">
                  {/* Image Side */}
                  <div className="md:w-1/2" data-id="element-597">
                    <div className="relative rounded-lg overflow-hidden" data-id="element-598">
                      <img src={currentEvent.image || 'https://images.unsplash.com/photo-1506318137071-a8e063b4bec0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3540&q=80'} alt={currentEvent.title} className="w-full aspect-video object-cover" data-id="element-599" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" data-id="element-600"></div>
                      <div className="absolute bottom-4 left-4 right-4" data-id="element-601">
                        <div className="flex items-center text-sm font-mono" data-id="element-602">
                          {getCategoryIcon(currentEvent.category)}
                          <span className={`
                            ${currentEvent.category === 'release' ? 'text-pink-400' : ''}
                            ${currentEvent.category === 'concert' ? 'text-purple-400' : ''}
                            ${currentEvent.category === 'formation' ? 'text-blue-400' : ''}
                            ${currentEvent.category === 'announcement' ? 'text-green-400' : ''}
                          `} data-id="element-603">
                            {currentEvent.category.toUpperCase()}
                          </span>
                        </div>
                        <h3 className="text-2xl font-bold text-white" data-id="element-604">
                          {currentEvent.title}
                        </h3>
                        <div className="text-sm font-mono text-gray-300 mt-1" data-id="element-605">
                          {currentEvent.date}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Content Side */}
                  <div className="md:w-1/2" data-id="element-606">
                    <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-607">
                      {currentEvent.description}
                    </p>
                    {currentEvent.spotifyId && <div className="mt-4" data-id="element-608">
                        <h4 className="text-white font-semibold mb-2" data-id="element-609">
                          Listen:
                        </h4>
                        <iframe src={`https://open.spotify.com/embed/track/${currentEvent.spotifyId}?utm_source=generator&theme=0`} width="100%" height="80" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className="rounded" data-id="element-610"></iframe>
                      </div>}
                    <div className="flex justify-between mt-8" data-id="element-611">
                      <button onClick={prevEvent} className={`flex items-center px-4 py-2 rounded bg-gray-800 text-white transition-colors ${activeEvent === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-700'}`} disabled={activeEvent === 0} data-id="element-612">
                        <ChevronLeftIcon size={18} className="mr-1" data-id="element-613" />
                        Previous
                      </button>
                      <button onClick={nextEvent} className={`flex items-center px-4 py-2 rounded bg-gray-800 text-white transition-colors ${activeEvent === filteredEvents.length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-700'}`} disabled={activeEvent === filteredEvents.length - 1} data-id="element-614">
                        Next
                        <ChevronRightIcon size={18} className="ml-1" data-id="element-615" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Timeline */}
              <div className="relative mt-12 pb-4" data-id="element-616">
                <div className="absolute left-0 right-0 top-1/2 h-0.5 bg-gray-700 transform -translate-y-1/2" data-id="element-617"></div>
                <div ref={timelineRef} className="relative flex items-center overflow-x-auto hide-scrollbar py-4" data-id="element-618">
                  {filteredEvents.map((event, index) => <button key={event.id} className={`flex-shrink-0 mx-4 first:ml-0 last:mr-0 flex flex-col items-center relative ${index === activeEvent ? 'opacity-100' : 'opacity-50 hover:opacity-80'}`} onClick={() => setActiveEvent(index)} data-id="element-619">
                      <div className={`w-4 h-4 rounded-full ${index === activeEvent ? 'bg-pink-500 ring-4 ring-pink-500/20' : 'bg-gray-600'}`} data-id="element-620"></div>
                      <div className={`text-xs font-mono mt-2 whitespace-nowrap ${index === activeEvent ? 'text-pink-400' : 'text-gray-400'}`} data-id="element-621">
                        {event.date}
                      </div>
                    </button>)}
                </div>
              </div>
            </> : <div className="text-center py-12" data-id="element-622">
              <div className="w-16 h-16 mx-auto bg-gray-800 rounded-full flex items-center justify-center mb-4" data-id="element-623">
                <CalendarIcon size={24} className="text-gray-400" data-id="element-624" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2" data-id="element-625">
                No events found
              </h3>
              <p className="text-gray-400" data-id="element-626">
                Try selecting a different category filter
              </p>
            </div>}
        </div>
      </div>
    </section>;
};
export default Timeline;